export default __webpack_public_path__ + "static/media/home-image.3ee495d8.png";